'use strict';

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _partner = require('./partner');

var _partner2 = _interopRequireDefault(_partner);

var _customer = require('./customer');

var _customer2 = _interopRequireDefault(_customer);

var _csr = require('./csr');

var _csr2 = _interopRequireDefault(_csr);

var _categories = require('./categories/categories');

var _categories2 = _interopRequireDefault(_categories);

var _settings = require('./settings/settings');

var _settings2 = _interopRequireDefault(_settings);

var _releases = require('./releases/releases');

var _releases2 = _interopRequireDefault(_releases);

var _http = require('./network/http');

var _http2 = _interopRequireDefault(_http);

var _apiClient = require('./network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _graphClient = require('./network/graph-client');

var _graphClient2 = _interopRequireDefault(_graphClient);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _store = require('./services/store');

var _store2 = _interopRequireDefault(_store);

var _modelProvider = require('./model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

var _me = require('./me/me');

var _me2 = _interopRequireDefault(_me);

var _quiqee = require('./quiqee');

var _quiqee2 = _interopRequireDefault(_quiqee);

var _courier = require('./courier');

var _courier2 = _interopRequireDefault(_courier);

var _slugs = require('./slugs/slugs');

var _slugs2 = _interopRequireDefault(_slugs);

var _visitor = require('./visitor/visitor');

var _visitor2 = _interopRequireDefault(_visitor);

var _search = require('./search/search');

var _search2 = _interopRequireDefault(_search);

var _client = require('./network/client');

var _client2 = _interopRequireDefault(_client);

var _profile = require('./profile');

var _profile2 = _interopRequireDefault(_profile);

var _eventManager = require('./event-manager/event-manager');

var _eventManager2 = _interopRequireDefault(_eventManager);

var _quLog = require('./utils/qu-log');

var _quLog2 = _interopRequireDefault(_quLog);

var _time = require('./time/time');

var _time2 = _interopRequireDefault(_time);

var _healthcheck = require('./healthcheck/healthcheck');

var _healthcheck2 = _interopRequireDefault(_healthcheck);

var _insurance = require('./insurance');

var _insurance2 = _interopRequireDefault(_insurance);

var _privacy = require('./privacy');

var _privacy2 = _interopRequireDefault(_privacy);

var _orders = require('./orders');

var _orders2 = _interopRequireDefault(_orders);

var _gateway = require('./gateway');

var _gateway2 = _interopRequireDefault(_gateway);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function use(plugin) {
  plugin(this);
}

var QuiqupJS = {
  ApiClient: _apiClient2.default,
  GraphClient: _graphClient2.default,
  Auth: _auth2.default,
  Categories: _categories2.default,
  config: _config2.default,
  Courier: _courier2.default,
  Customer: _customer2.default,
  EventManager: _eventManager2.default,
  http: _http2.default,
  Me: _me2.default,
  ModelProvider: _modelProvider2.default,
  Partner: _partner2.default,
  Quiqee: _quiqee2.default,
  Releases: _releases2.default,
  Settings: _settings2.default,
  Slugs: _slugs2.default,
  store: _store2.default,
  use: use,
  Visitor: _visitor2.default,
  Search: _search2.default,
  Client: _client2.default,
  Profile: _profile2.default,
  Logger: _quLog2.default,
  Time: _time2.default,
  Healthcheck: _healthcheck2.default,
  Insurance: _insurance2.default,
  Csr: _csr2.default,
  Privacy: _privacy2.default,
  Orders: _orders2.default,
  Gateway: _gateway2.default
};

QuiqupJS.default = QuiqupJS;

module.exports = QuiqupJS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/index.js
// module id = 425
// module chunks = 0